import { routeDefinitions, type RouteRecordRaw } from '@gat-ship/lib/router'

export function createMonetaryRoutes(
  startPath: string
): readonly RouteRecordRaw[] {
  return [
    {
      path: startPath,
      component: () => import('../layouts/route-layout.vue'),
      children: [
        {
          path: 'currencies',
          children: [
            {
              path: '',
              component: () => import('../views/view-currencies.vue'),
              name: routeDefinitions.administration.currencyCodes
            }
          ]
        }
      ]
    }
  ]
}
